export default "__VITE_ASSET__910d1d26__"